import React, { useState } from "react";
import { CardMedia, CardActionArea, Card, CardContent, Typography, Box } from "@mui/material";
import ArticleControls from './ArticleControls.js'
import { editArticleMetadata, isNewArticle } from '../utils.js'
import DeleteArticleDialog from "./DeleteArticleDialog.js";
import Tags from "../Tags.js";
import { useNavigate } from "react-router-dom";

export default function ArticleCard(props = {}) {
  const navigate = useNavigate()
  const {
    index,
    article,
    maxWidth = '100%',
    minHeight = undefined,
    editable,
    published,
    sx = {},
    visibility
  } = props

  const [hovering, setHovering] = useState(false)
  const [deleteArticleDialogOpen, setDeleteArticleDialogOpen] = useState(false)
  const showNewIndicator = isNewArticle(article)

  const viewArticle = () => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      if (article?.guid) {
        navigate(article.guid)
      } else if (article?.webUrl) {
        window.open(article.webUrl, "_blank", "noopener,noreferrer")
      }
    }
  }

  return (<>
    <DeleteArticleDialog
      open={deleteArticleDialogOpen}
      article={article}
      onClose={() => setDeleteArticleDialogOpen(false)}
    />

    <Card
      sx={{
        display: 'flex',
        ...sx
      }}
      key={'article' + index}
      className="secondary-article-card"
      style={{
        maxWidth,
        minHeight
      }}>
      <CardActionArea
        component='div'
        sx={{ display: 'flex', position: 'relative' }}
        onMouseOver={() => setHovering(true)}
        onMouseOut={() => setHovering(false)}
        onClick={() => viewArticle()}
      >
        {showNewIndicator && <Box
          sx={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            zIndex: 6,
            pointerEvents: 'none',
            borderRadius: '5px',
            px: '8px',
            py: '2px',
            backgroundColor: '#FFF4CC'
          }}
        >
          <Typography
            variant="body2"
            component="span"
            sx={{
              color: '#F40009',
              fontWeight: 700,
              letterSpacing: '.4px',
              lineHeight: 1.2
            }}
          >
            NEW
          </Typography>
        </Box>}
        <Box 
        className="image-overlay"
         />
        {/* <Box className=".gradient-overlay" /> */}
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image" />
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image-blurred" />

        <CardContent className="secondary-article-content" >
          <div>
            <Typography variant="body1" className="secondary-article-title">
              {article.title}
            </Typography>
            <Typography variant="caption">
              {article.author} - {article.date}
            </Typography>
          </div>
          <Tags
            tags={article?.tags || ""}
            onSelectTag={_ => setHovering()}
            clickable={published}
            sx={{ marginTop: '4px' }}
          />
        </CardContent>
        {editable && <ArticleControls
          isDraft={article?.isDraft}
          isPinned={article?.metadata?.isPinned}
          hovering={hovering}
          onClickEdit={() => editArticleMetadata(article, visibility)}
          onClickDelete={() => setDeleteArticleDialogOpen(true)}
          showAdd={false}
          article={article}
        />}
      </CardActionArea>

    </Card>
  </>)
}